module.exports = __webpack_public_path__ + "img/icon_register@2x.c6157aef.png";